/**
 * Mã lỗi ghi sổ
 * NNLINH 12.07.2022
 */
export default {
    //Warning
    Post_Voucher_InGLVoucherList: 'Chứng từ này đã được lập trong bảng tổng hợp chứng từ cùng loại hoặc bảng kê. Chương trình sẽ tự động loại bỏ chứng từ này nếu thấy không hợp lệ.',
    Post_Voucher_InVoucherSummary: 'Chứng từ này đã được lập trong bảng tổng hợp chứng từ cùng loại. Chương trình sẽ tự động loại bỏ chứng từ này nếu thấy không hợp lệ.',
    Post_Voucher_InBUVoucherList: 'Chứng từ này đã lập bảng kê. Chương trình sẽ tự động loại bỏ chứng từ này nếu chứng từ không hợp lệ.',
    Post_ExsistTAPurchaseSaleList: 'Chương trình đã tự động loại bỏ hạch toán chi tiết có thay đổi thông tin nhóm HHDV ra khỏi bảng kê mua vào/bán ra.',

    // Error
    Post_ValidateVerifyAccount: 'Định khoản không hợp lệ. Ghi sổ không thành công',
    Post_NotZeroAmount: 'Giá trị hạch toán phải khác 0. Ghi sổ không thành công',
    Post_VoucherInvalid: 'Đã xảy ra lỗi ghi sổ không thành công',
    Post_ValidAccDetailBy_AccountingObject: 'Cán bộ',
    Post_ValidAccDetailBy_Activity: 'Hoạt động',
    Post_ValidAccDetailBy_Chapter: 'Chương',
    Post_ValidAccDetailBy_BudgetItem: 'Mục',
    Post_ValidAccDetailBy_BudgetSubItem: 'Tiểu mục',
    Post_ValidAccDetailBy_BudgetKindItem: 'Loại',
    Post_ValidAccDetailBy_BudgetSubKindItem: 'Khoản',
    Post_ValidAccDetailBy_BudgetSource: 'Nguồn',
    Post_ValidAccDetailBy_Fund: 'Loại quỹ',
    Post_ValidAccDetailBy_Method: 'Cấp phát',
    Post_ValidAccDetailBy_Project: 'CTMT',
    Post_ValidAccDetailBy_Task: 'Nhiệm vụ',
    Post_ValidAccDetailBy_BankAccount: 'Tài khoản NH,KB',
    Post_ValidAccDetailBy_Contract: 'Hợp đồng',

    // Yes/no
    UnPost_ErrorUnPostExistInGLVoucherList:' Chứng từ {1} đã được lập Bảng tổng hợp chứng từ cùng loại {0}/Chứng từ ghi sổ {0}. Để bỏ ghi sổ {0}, chương trình sẽ loại bỏ {1} khỏi Chứng từ ghi sổ/Bảng tổng hợp chứng từ cùng loại. Bạn có muốn bỏ ghi không?',
    UnPost_Warning_OutwardBeUpdated: 'Việc bỏ ghi này sẽ dẫn đến các chứng từ {0} cũng sẽ bị bỏ ghi theo, bạn có tiếp tục không?',
    Post_QuestionClosingDebit: 'Số dư của tài khoản <{0}> đến ngày {1}  chỉ còn {2}. Bạn có muốn ghi sổ (chấp nhận xuất quỹ tiền âm) không?',
    Post_QuestionPurchasePurpose: 'Cần nhập thông tin ""Nhóm HHDV"" để lên Bảng kê hóa đơn, chứng từ hàng hóa, dịch vụ mua vào. Bạn có muốn bổ sung thêm trước khi ghi sổ không?',
    Post_Warning_OutwardBeUpdated: 'Việc ghi sổ này sẽ dẫn đến các chứng từ {0} cũng sẽ được ghi sổ theo, bạn có tiếp tục không?',

    //Error code
    UnPost_ErrorExistInBUVoucherList_Code: 'UnPost_ErrorExistInBUVoucherList',
    UnPost_ErrorUnPostExistInGLVoucherList_Code :'UnPost_ErrorUnPostExistInGLVoucherList',

    //Title
    UnPost_ErrorExistInBUVoucherList_Title: 'Không thể bỏ ghi chứng từ',
    //Button
    UnPost_ErrorExistInBUVoucherList_Button: 'Xem bảng kê',
    //Message
    UnPost_ErrorExistInBUVoucherList: 'Cần thực hiện hủy thanh toán trước khi bỏ ghi chứng từ do chứng từ này đã thanh toán trên bảng kê <span class="color-green">{0}</span>',
    UnPost_ErrorExistInBUVoucherList_Multi: 'Chứng từ đã được thanh toán trên bảng kê số <span class="color-blue">{0}</span>.',
    UnPost_ErrorUnPostExistInGLVoucherList_All:'Chứng từ {1} đã được lập Bảng tổng hợp chứng từ cùng loại {0} và Chứng từ ghi sổ {2}. Để bỏ ghi sổ {1}, chương trình sẽ loại bỏ {1} khỏi Chứng từ ghi sổ và Bảng tổng hợp chứng từ cùng loại. Bạn có muốn bỏ ghi không?',
    UnPost_ErrorUnPostExistInGLVoucherList_Summary:'Chứng từ {1} đã được lập Bảng tổng hợp chứng từ cùng loại {0}. Để bỏ ghi sổ {1}, chương trình sẽ loại bỏ {1} khỏi Bảng tổng hợp chứng từ cùng loại. Bạn có muốn bỏ ghi không?',
    UnPost_ErrorUnPostExistInGLVoucherList_Voucher: 'Chứng từ {1} đã được lập Chứng từ ghi sổ {0}. Để bỏ ghi sổ {1}, chương trình sẽ loại bỏ {1} khỏi Chứng từ ghi sổ. Bạn có muốn bỏ ghi không?',
    
    
    
    // Message cho xóa nhiều và bỏ ghi chứng từ liên quan
    DeleteUnPost_ErrorUnPostExistInGLVoucherList_Voucher: 'Chứng từ đã được lập Chứng từ ghi sổ {0}',
    DeleteUnPost_ErrorUnPostExistInGLVoucherList_Summary:'Chứng từ đã được lập Bảng tổng hợp chứng từ cùng loại {0}',
    DeleteUnPost_ErrorUnPostExistInGLVoucherList_All:'Chứng từ {1} đã được lập Bảng tổng hợp chứng từ cùng loại {0} và Chứng từ ghi sổ {2}',


    // Mã lỗi chứng từ
    GENERATE_DATA :'GENERATE_DATA',
    VALIDATE: 'VALIDATE',


    // Mã code lỗi
    Delete_ErrorIsPostedVoucher: 'Delete_ErrorIsPostedVoucher',
    Delete_ErrorRelationVoucher: 'Delete_ErrorRelationVoucher',


    // Message lỗi tương ứng với mã code

    Message_Delete_ErrorIsPostedVoucher: 'Chứng từ này đã được ghi sổ. Vui lòng kiểm tra lại.',
    // Message_Delete_ErrorRelationVoucher: 'Chứng từ này đã được ghi sổ. Vui lòng kiểm tra lại.',





}